"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Estimate_1 = require("../controllers/Estimate");
const useDeepComparisonEffect_1 = __importDefault(require("./useDeepComparisonEffect"));
const useStatus_1 = __importDefault(require("./useStatus"));
function useTripEstimates(react, trip, waveApiUrl) {
    const _a = (0, useStatus_1.default)(react), { handlePromise, isPending } = _a, status = __rest(_a, ["handlePromise", "isPending"]);
    const coordinates = trip === null || trip === void 0 ? void 0 : trip.locations.map(l => l === null || l === void 0 ? void 0 : l.coordinates);
    (0, useDeepComparisonEffect_1.default)(react, () => {
        if ((trip === null || trip === void 0 ? void 0 : trip.locations) && !trip.locations.includes(undefined)) {
            handlePromise((0, Estimate_1.estimateCreate)(trip, waveApiUrl));
        }
    }, [trip === null || trip === void 0 ? void 0 : trip.couponCode, coordinates, handlePromise]);
    return Object.assign({ isPending }, status);
}
exports.default = useTripEstimates;
